import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { phoneReg } from '../../utils/phone';
import { ERROR_CODE, ERROR_CODE_ZH } from '../../constants/login';
import { resetPassWord, sendVerifyCode } from '../../service/login';
import { useMsgFail } from '../../utils/antd-message';
import { encryptStr } from '../../utils/encryp';
import './index.less';
import '../../styles/input.less';
import { formatCode, formatPhone, onNumberInputChange } from '../..';
import { BtnSave } from '../personal-data/components/btn-save';
import { useStatistics } from '../../utils/statistics';
export var RESET_TYPE;
(function (RESET_TYPE) {
  RESET_TYPE[RESET_TYPE["RESET"] = 0] = "RESET";
  RESET_TYPE[RESET_TYPE["UPDATE"] = 1] = "UPDATE";
})(RESET_TYPE || (RESET_TYPE = {}));
var validatePassword = function validatePassword(psd) {
  if (/^\S*\S*$/.test(psd)) {
    if (psd.length < 8 || psd.length > 20 || /\s/.test(psd)) {
      return false;
    }
    var count = 0;
    if (/\d/.test(psd)) {
      count++;
    }
    if (/[A-Z]/.test(psd)) {
      count++;
    }
    if (/[a-z]/.test(psd)) {
      count++;
    }
    if (/[^0-9]/.test(psd) && /[^A-Z]/.test(psd) && /[^a-z]/.test(psd)) {
      count++;
    }
    if (count >= 2) {
      return true;
    }
  }
  return false;
};
export function ResetPassword(_ref) {
  var style = _ref.style,
    className = _ref.className,
    onClick = _ref.onClick,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? RESET_TYPE.RESET : _ref$type,
    userPhone = _ref.userPhone,
    active = _ref.active;
  useStatistics('ResetPassword');
  var MsgFail = useMsgFail();
  var _useState = useState('获取验证码'),
    _useState2 = _slicedToArray(_useState, 2),
    verifyText = _useState2[0],
    setVerifyText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    verifyDisabled = _useState4[0],
    setVerifyDisabled = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    phone = _useState6[0],
    setPhone = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    code = _useState8[0],
    setCode = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    password = _useState10[0],
    setPassword = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    newPassword = _useState12[0],
    setNewPassword = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    phoneErr = _useState14[0],
    setPhoneErr = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    codeErr = _useState16[0],
    setCodeErr = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    passwordErr = _useState18[0],
    setPasswordErr = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    newPasswordErr = _useState20[0],
    setNewPasswordErr = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isSaving = _useState22[0],
    setIsSaving = _useState22[1];
  var timer = useRef(0);
  // 是更新密码还是重置密码
  var isUpdatePassword = type === RESET_TYPE.UPDATE;
  var isCodeValid = useMemo(function () {
    return code.length === 6 && !/[^0-9]/.test(code);
  }, [code]);
  var isPhoneValid = useMemo(function () {
    return phoneReg.test(phone);
  }, [phone]);
  var isPsdValid = useMemo(function () {
    return validatePassword(password);
  }, [password]);
  var isNewPsdValid = useMemo(function () {
    return password === newPassword;
  }, [newPassword, password]);
  var resetCode = function resetCode() {
    clearInterval(timer.current);
    setVerifyDisabled(false);
    setVerifyText('获取验证码');
  };
  var handleSendCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var encrypPhone, seconds, _e$response, _e$response$data, text, _e$response2, _e$response2$data, _e$response3, _e$response3$data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(verifyDisabled || !isPhoneValid)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            encrypPhone = encryptStr(phone);
            _context.next = 6;
            return sendVerifyCode({
              phone: encrypPhone
            });
          case 6:
            setVerifyDisabled(true);
            seconds = 60;
            setVerifyText("".concat(seconds, " \u79D2\u540E\u91CD\u8BD5"));
            timer.current = window.setInterval(function () {
              seconds--;
              setVerifyText("".concat(seconds, " \u79D2\u540E\u91CD\u8BD5"));
              if (seconds <= 0) {
                resetCode();
              }
            }, 1000);
            _context.next = 19;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            console.warn(_context.t0);
            resetCode();
            text = '';
            if ((_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.code) {
              text = ERROR_CODE_ZH[_context.t0.response.data.code];
              if (((_e$response2 = _context.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.code) === ERROR_CODE.USER_NOT_FOUND) {
                text = '无法设置密码，账号无权限，请联系学校管理员';
              }
            } else {
              text = (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response3 = _context.t0.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.message) || '系统错误';
            }
            MsgFail(text);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function handleSendCode() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleOk = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$resetPassWord, _yield$resetPassWord$, codeRes, message, text, _e$response4, _e$response4$data, _text, _e$response5, _e$response5$data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!(isCodeValid && isPhoneValid && isPsdValid && isNewPsdValid && !isSaving)) {
              _context2.next = 11;
              break;
            }
            setIsSaving(true);
            // const FN = type === RESET_TYPE.RESET ? resetPassWord
            _context2.next = 5;
            return resetPassWord({
              password: encryptStr(password),
              phone: encryptStr(phone),
              verification: encryptStr(code)
            });
          case 5:
            _yield$resetPassWord = _context2.sent;
            _yield$resetPassWord$ = _yield$resetPassWord.data;
            codeRes = _yield$resetPassWord$.code;
            message = _yield$resetPassWord$.message;
            if (codeRes === '0') {
              onSuccess && onSuccess();
            } else {
              text = '';
              if (message) {
                // text = ERROR_CODE_ZH[codeRes as ERROR_CODE]
                // if (codeRes === ERROR_CODE.USER_NOT_FOUND) {
                //   text = '无法设置密码，账号无权限，请联系学校管理员'
                // }
                text = message;
              } else {
                text = '系统错误';
              }
              MsgFail(text);
              onError && onError(codeRes);
            }
            setIsSaving(false);
          case 11:
            _context2.next = 21;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](0);
            setIsSaving(false);
            console.warn(_context2.t0);
            _text = '';
            if ((_e$response4 = _context2.t0.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.message) {
              // text = ERROR_CODE_ZH[e.response.data.code as ERROR_CODE]
              _text = (_e$response5 = _context2.t0.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.message;
              // if (e.response?.data?.code === ERROR_CODE.USER_NOT_FOUND) {
              //   text = '无法设置密码，账号无权限，请联系学校管理员'
              // }
            } else {
              _text = '系统错误';
            }
            MsgFail(_text);
            onError && onError(_context2.t0);
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 13]]);
    }));
    return function handleOk() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (userPhone) {
      setPhone(userPhone);
    }
  }, [userPhone]);
  useEffect(function () {
    return function () {
      clearInterval(timer.current);
    };
  }, []);
  useEffect(function () {
    if (!active) {
      resetCode();
      if (type === RESET_TYPE.RESET) {
        setPhone('');
      }
      setCode('');
      setPassword('');
      setNewPassword('');
      setPhoneErr('');
      setCodeErr('');
      setPasswordErr('');
      setNewPasswordErr('');
    }
  }, [active, type]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick,
    className: "".concat(className, " login-reset-password")
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      // height: 'calc(100% - 64px)',
      // paddingBottom: '64px',
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-reset-password-content",
    style: type === RESET_TYPE.RESET ? {
      width: '280px'
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-reset-password-tips"
  }, "\u5B8C\u6210\u8D26\u53F7\u5B89\u5168\u9A8C\u8BC1\u540E\uFF0C\u53EF\u8BBE\u7F6E\u767B\u5F55\u5BC6\u7801"), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-phone",
    onBlur: function onBlur(e) {
      var inputPhone = e.target.value.replace(/[^0-9]/g, '');
      if (inputPhone.length === 0) {
        setPhoneErr('请输入手机号');
      } else if (!phoneReg.test(inputPhone)) {
        setPhoneErr('手机号格式错误');
      } else {
        setPhoneErr('');
      }
    },
    value: formatPhone(phone),
    type: "text",
    onChange: function onChange(e) {
      if (!isUpdatePassword) {
        onNumberInputChange(e, 11, setPhone);
      }
    },
    readOnly: isUpdatePassword,
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7"
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, phoneErr)), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-code",
    onBlur: function onBlur(e) {
      var inputCode = e.target.value.replace(/[^0-9]/g, '');
      if (inputCode.length === 0) {
        setCodeErr('请输入验证码');
      } else if (inputCode.length !== 6 || /[^0-9]/.test(inputCode)) {
        setCodeErr('验证码为6位数字');
      } else {
        setCodeErr('');
      }
    },
    value: formatCode(code),
    onChange: function onChange(e) {
      onNumberInputChange(e, 6, setCode);
    },
    type: "text",
    placeholder: "\u8BF7\u8F93\u51656\u4F4D\u9A8C\u8BC1\u7801"
  }), /*#__PURE__*/React.createElement("span", {
    style: !isPhoneValid || verifyDisabled ? {
      cursor: 'not-allowed',
      minWidth: '80px'
    } : {},
    className: "login-input-sendCode ".concat(isPhoneValid && !(!isPhoneValid || verifyDisabled) ? 'active' : ''),
    onClick: handleSendCode
  }, verifyText), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, codeErr)), /*#__PURE__*/React.createElement("div", {
    className: "login-reset-password-tips",
    style: {
      marginTop: '12px'
    }
  }, "\u5BC6\u7801\u957F\u5EA6\u57288-20\u4F4D\uFF0C\u5E94\u5305\u542B\u6570\u5B57\u3001\u5927\u5199\u5B57\u6BCD\u3001\u5C0F\u5199\u5B57\u6BCD\u3001\u7B26\u53F7\uFF08\u9664\u7A7A\u683C\uFF09\u7684\u4E24\u79CD\u6216\u4EE5\u4E0A"), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 0,
      height: 0
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "text"
  })), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-password",
    onBlur: function onBlur(e) {
      if (e.target.value.length === 0) {
        setPasswordErr('请输入新密码');
      } else if (!validatePassword(e.target.value)) {
        setPasswordErr('密码格式不正确');
      } else {
        setPasswordErr('');
      }
      if (newPassword.length !== 0 && e.target.value.length !== 0) {
        if (newPassword !== e.target.value) {
          setNewPasswordErr('两次输入密码不一致');
        } else {
          setNewPasswordErr('');
        }
      }
    },
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    type: "password",
    placeholder: "\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801"
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, passwordErr)), /*#__PURE__*/React.createElement("div", {
    className: "login-input-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: "login-input-password",
    onBlur: function onBlur(e) {
      if (e.target.value.length === 0) {
        setNewPasswordErr('请再次输入新密码');
      } else if (e.target.value !== password) {
        setNewPasswordErr('两次输入密码不一致');
      } else {
        setNewPasswordErr('');
      }
    },
    value: newPassword,
    onChange: function onChange(e) {
      return setNewPassword(e.target.value);
    },
    type: "password",
    placeholder: "\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801"
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-input-text-error"
  }, newPasswordErr)), /*#__PURE__*/React.createElement(BtnSave, {
    confirmDisabled: !(isCodeValid && isPhoneValid && isPsdValid && isNewPsdValid),
    onConfirm: handleOk,
    isSaving: isSaving
  }))));
}